module.exports = __webpack_public_path__ + "img/priyanka.09228010.jpg";